import { render, staticRenderFns } from "./CreateEditExamModal.vue?vue&type=template&id=27b8a98e&"
import script from "./CreateEditExamModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditExamModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditExamModal.vue?vue&type=style&index=0&id=27b8a98e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports